import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { InfoIcon } from '@beef/ui-kit';

import { MOBILE_TEXT_SIZE, DESKTOP_TEXT_SIZE, HIDE_BUTTON, DETAILS_BUTTON } from './const';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function PointDopInfo({ info, isCompact }) {
  const [isShownFull, toggleVisibility] = useState(false);
  const sizeText = isCompact ? MOBILE_TEXT_SIZE : DESKTOP_TEXT_SIZE;

  const changeShownInfo = (text) => text.substring(0, sizeText);

  const shownInfo = isShownFull ? info : changeShownInfo(info);
  const showToggler = !!(info.length >= sizeText);
  const togglerName = isShownFull ? HIDE_BUTTON : DETAILS_BUTTON;

  return (
    <div className={cx('component')}>
      <div className={cx('info')}>
        <InfoIcon fill="#727281" />
      </div>
      <div className={cx('text')}>
        {shownInfo}
        {showToggler ?
          <span
            className={cx('link')}
            onClick={(e) => {
              e.stopPropagation();
              toggleVisibility(!isShownFull);
            }}
            role="button"
            tabIndex={0}
          >
            {togglerName}
          </span>
        : null}
      </div>
    </div>
  );
}

PointDopInfo.propTypes = {
  info: PropTypes.string,
  isCompact: PropTypes.bool,
};

PointDopInfo.defaultProps = {
  info: '',
};
